module.exports = vendor_other_lib;